import { Utils } from "../_common/utils";
import { EvidenceProvider } from "./evidence-provider";
import { MultiLanguageString } from "./multi-language-string";

export class Evidence {
    success: boolean;
    message: string;
    jurisdictionLevel: string;
    jurisdictionContextId: string;
    dataServiceEvidenceTypeIdentifier: string;
    showJurisdictionSelect: boolean;
    evidenceIdentifier: string;
    evidenceUUID: string;
    requirementId: string;
	evidenceTypeClassification: string;
	evidenceTitle: MultiLanguageString[];
    evidenceNumber: number;
    countryCode: string;
	providers: EvidenceProvider[];
    previewUrl: string;
    isPreview: boolean;
    fileName: string;
    base64File: string;
    structuredData: any;
    mimeType: string;
    status: string;
    previousStatus: string;
    errorMessage:string;
    mandatory: boolean;
    uploadAllowed: boolean;
    providerCountryCode: string;
    isTimeout: boolean;
    accessServiceIdentifier: string;
    publisherIdentifier: string;
    publisherName: string;
    requirementNumber: number;
    jurisdictionAdminL2: string;
    jurisdictionAdminL3: string;

    get selectedProvider() : any {
        if(Utils.isNullOrUndefined(this.providers)) return null;
        return this.providers.find(provider => provider.isSelected) ?? null;
    }
 
  /*   transformToSave(): EvidenceSave{

    } */
   fillDataEvidence(evidence: Evidence) {
    this.success = evidence.success;
    this.message = evidence.message;
    this.jurisdictionLevel = evidence.jurisdictionLevel;
    this.jurisdictionContextId = evidence.jurisdictionContextId;
    this.dataServiceEvidenceTypeIdentifier = evidence.dataServiceEvidenceTypeIdentifier;
    this.showJurisdictionSelect = evidence.showJurisdictionSelect;
    this.evidenceIdentifier = evidence.evidenceIdentifier;
    this.evidenceUUID = evidence.evidenceUUID;
    this.requirementId = evidence.requirementId;
	this.evidenceTypeClassification = evidence.evidenceTypeClassification;
	this.evidenceTitle = evidence.evidenceTitle;
    this.evidenceNumber = evidence.evidenceNumber;
    this.countryCode = evidence.countryCode;
	this.providers = evidence.providers;
    this.previewUrl = evidence.previewUrl;
    this.isPreview = evidence.isPreview;
    this.fileName = evidence.fileName;
    this.base64File = evidence.base64File;
    this.mimeType = evidence.mimeType;
    this.structuredData = evidence.structuredData;
    this.status = evidence.status;
    this.previousStatus = evidence.previousStatus;
    this.errorMessage = evidence.errorMessage;
    this.mandatory = evidence.mandatory;
    this.uploadAllowed = evidence.uploadAllowed;
    this.providerCountryCode = evidence.providerCountryCode;
    this.isTimeout = evidence.isTimeout;
    this.accessServiceIdentifier = evidence.accessServiceIdentifier;
    this.publisherIdentifier = evidence.publisherIdentifier;
    this.publisherName = evidence.publisherName;
    this.requirementNumber = evidence.requirementNumber;
    this.jurisdictionAdminL2 = evidence.jurisdictionAdminL2;
    this.jurisdictionAdminL3 = evidence.jurisdictionAdminL3;
   }

    
}
export interface EvidenceSave{
    evidenceUUID: string;
    accessServiceIdentifier: string;
    base64File: string;
    evidenceIdentifier: string;
    evidenceNumber: number;
    evidenceTitle: string;
    fileName: string;
    mimeType: string;
    previewUrl: string;
    publisherName: string;
    requirementId: string;
    status: string;
}